import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
		borderColor: theme.other.colors.border.primary
	}
} ) );
